module.exports = __webpack_public_path__ + "static/media/bi_exi.5055ff16.pdf";